import { render, staticRenderFns } from "./EventsDetailsPeriod.vue?vue&type=template&id=312b3620&scoped=true"
import script from "./EventsDetailsPeriod.vue?vue&type=script&lang=js"
export * from "./EventsDetailsPeriod.vue?vue&type=script&lang=js"
import style0 from "./EventsDetailsPeriod.vue?vue&type=style&index=0&id=312b3620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b3620",
  null
  
)

export default component.exports